<template>
    <div class="leftPart">
        <el-menu class="asideMenu"
                :default-active="actIndex"
                 router
                 background-color="#f2f2f2"
                 @select="handleSelect"
                 :collapse="isCollapse">
            <el-menu-item index="/main">
                <i class="el-icon-menu"></i>
                <span slot="title">首页</span>
            </el-menu-item>
            <menu-tree :list="menuList" :isCollapse="isCollapse"></menu-tree>
        </el-menu>
    </div>
</template>

<script type="text/javascript">
    import MenuTree from "@/components/home/menuTree";

    export default {
        name: "asideMenu",
        props: ['isCollapse', 'actIndex'],
        components: {
            MenuTree
        },
        data() {
            return {
                menuList: this.$store.state.loginInfo.menuList
            }
        },
        methods: {
            handleSelect(index, indexPath) {
                this.$emit('hand-change', index)
            },
        }
    }
</script>

<style scoped>
    .leftPart {
        background: #f2f2f2;
        box-shadow: 2px 0 8px 0 rgba(29, 35, 41, .05);
        left: 0;
        z-index: 999;
        width: 220px;
        overflow-y: auto;
        height:calc(100vh - 100px);
        text-align: left;
    }
    .asideMenu{
        top: 0;
        margin-bottom: 30px;
    }
</style>